let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k3Tff")).then(() => parcelRequire('4HuAu'));